import React from "react";
import SuccessCard from "./SuccessCard";
import DangerCard from "./DangerCard";
import NormalCard from "./NormalCard";
import STATISTICS_API from "api/statisticsApi";
import { useSelector } from "react-redux";
import { useFetch } from "@hooks/useStatApi";
import "./DarkCard.scss";
import BatchInfoCard from "./BatchInfoCard";

const StatisticsCards = ({setBatchData, supplierName, supplierID, batchData }) => {
  const batchID = useSelector((state) => state.overview.batchId);
  console.log("supplierID98987", supplierID);
  const shouldFetch = supplierID !== null; // will be null initially, but maybe undefined is also meaningful

  const params = {
    supplierId: supplierID, // Use undefined if supplierID is null
    currentDate: new Date().toISOString().split("T")[0],
  };

  const { data: topIssuesData, isLoading: isTopIssuesDataLoading } = useFetch(
    "fetchTopIssue",
    STATISTICS_API.getTopIssueNew,
    shouldFetch ? params : null
  );

  const { data: defectRateData, isLoading: isdefectRateDataLoading } = useFetch(
    "fetchDefectRate",
    STATISTICS_API.getDefectRateNew,
    shouldFetch ? params : null
  );

  const { data: improvedAReaData, isLoading: isimprovedAReaDataLoading } =
    useFetch(
      "fetchimprovedARea",
      STATISTICS_API.getIproveRateNew,
      shouldFetch ? params : null
    );

  <BatchInfoCard />;
  return (
    <React.Fragment>
      <div className="block lg:grid lg:grid-cols-5 lg:gap-3 space-y-3 lg:space-y-0">
        {isimprovedAReaDataLoading ? (
          <div className="flex items-center justify-center h-24 w-full bg-gray-200 rounded animate-pulse">
            <div className="h-6 w-32 bg-gray-300 rounded"></div>
          </div>
        ) : (
          <SuccessCard
            title="Improved Area"
            subtitle={improvedAReaData?.data?.issue}
            stats={`${improvedAReaData?.data?.percentage}%`}
            statsicon={
              improvedAReaData?.data?.trend == "down" ? (
                <i class="ri-arrow-right-down-long-line"></i>
              ) : improvedAReaData?.data?.trend == "up" ? (
                <i class="ri-arrow-right-up-long-line"></i>
              ) : null
            }
            trend={improvedAReaData?.data?.trend}
            icon={<i class="ri-hand-heart-fill"></i>}
          />
        )}

        {isdefectRateDataLoading ? (
          <div className="flex items-center justify-center h-24 w-full bg-gray-200 rounded animate-pulse">
            <div className="h-6 w-32 bg-gray-300 rounded"></div>
          </div>
        ) : (
          <DangerCard
            title="Defect Rate"
            subtitle={defectRateData?.data?.label}
            stats={`${defectRateData?.data?.percentage}%`}
            statsicon={
              defectRateData?.data?.trend == "down" ? (
                <i class="ri-arrow-right-down-long-line"></i>
              ) : defectRateData?.data?.trend == "up" ?   (
                <i class="ri-arrow-right-up-long-line"></i>
              ) : null
            }
            trend={defectRateData?.data?.trend}
            icon={<i className="ri-alert-line"></i>}
          />
        )}

        {isTopIssuesDataLoading ? (
          <div className="flex items-center justify-center h-24 w-full bg-gray-200 rounded animate-pulse">
            <div className="h-6 w-32 bg-gray-300 rounded"></div>
          </div>
        ) : (
          <NormalCard
            title="Top Issues"
            subtitle={topIssuesData?.data?.issue}
            stats={`${topIssuesData?.data?.percentage}%`}
            statsicon={
              topIssuesData?.data?.trend == "down" ? (
                <i class="ri-arrow-right-down-long-line"></i>
              ) : topIssuesData?.data?.trend == "up" ? (
                <i class="ri-arrow-right-up-long-line"></i>
              ) : null
            }
            trend={topIssuesData?.data?.trend}
            icon={<i className="ri-delete-back-line"></i>}
          />
        )}
        <BatchInfoCard  setBatchData = {setBatchData} batchDatas={batchData} supplierName={supplierName} />
      </div>
    </React.Fragment>
  );
};

export default StatisticsCards;
